import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./mobilecontact.scss";

const Mobilecontact = () => {
  return (
    <a className="mobile-contact" href="tel:+995557396727">
      <span className="phone-icon-wrap">
        <FontAwesomeIcon icon={faPhone} />
      </span>
      <span className="phone-number">+995 557 396 727</span>
      <span className="phone-pulse"></span>
    </a>
  );
};

export default Mobilecontact;
